class PresseSliderV2 {
  constructor(container) {
    this.container = container;
    this.currentIndex = 0;
    this.swiper = null;
    this.quotes = [];
    this.logos = [];
    this.init();
  }

  init() {
    if (typeof Swiper === "undefined") {
      console.error("Swiper library not loaded");
      return;
    }

    this.setupElements();
    this.initSwiper();
    this.bindEvents();
  }

  setupElements() {
    this.quotes = Array.from(
      this.container.querySelectorAll(".presse-slider-v2__quote")
    );
    this.logos = Array.from(
      this.container.querySelectorAll(".presse-slider-v2__logo-container")
    );
    this.quoteWrapper = this.container.querySelector(
      ".presse-slider-v2__quote-wrapper"
    );

    // Set initial height based on active quote
    this.updateWrapperHeight();
  }

  initSwiper() {
    const swiperElement = this.container.querySelector(
      ".presse-slider-v2__logos-swiper"
    );
    if (!swiperElement) return;

    const isMobile = window.innerWidth <= 990;
    const initialSlideIndex = isMobile ? 0 : 2;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: "auto",
      spaceBetween: isMobile ? 24 : 54,
      centeredSlides: true,
      loop: false,
      initialSlide: initialSlideIndex,
      on: {
        slideChange: (swiper) => {
          this.updateActiveSlide(swiper.activeIndex);
        },
      },
      breakpoints: {
        991: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
      },
    });

    // Set initial active state for desktop (3rd slide = index 2)
    if (!isMobile) {
      this.currentIndex = -1; // Reset to allow updateActiveSlide to run
      this.updateActiveSlide(2);
    }
  }

  bindEvents() {
    // Click on logo to change quote
    this.logos.forEach((logo, index) => {
      logo.addEventListener("click", () => {
        this.updateActiveSlide(index);

        // Update swiper if mobile
        if (this.swiper && window.innerWidth <= 990) {
          this.swiper.slideTo(index);
        }
      });
    });

    // Pagination bullets click
    const bullets = this.container.querySelectorAll(
      ".swiper-pagination-bullet"
    );
    bullets.forEach((bullet) => {
      bullet.addEventListener("click", () => {
        const index = parseInt(bullet.getAttribute("data-bullet-index"));
        this.updateActiveSlide(index);

        // Update swiper if mobile
        if (this.swiper && window.innerWidth <= 990) {
          this.swiper.slideTo(index);
        }
      });
    });

    // Handle resize
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (this.swiper) {
          this.swiper.update();
        }
        // Update wrapper height on resize
        this.updateWrapperHeight();
      }, 250);
    });
  }

  updateWrapperHeight() {
    if (!this.quoteWrapper || this.quotes.length === 0) return;

    // Get height of current active quote
    const activeQuote = this.quotes[this.currentIndex];
    if (activeQuote) {
      const height = activeQuote.offsetHeight;
      this.quoteWrapper.style.minHeight = `${height}px`;
    }
  }

  updateActiveSlide(index) {
    if (index === this.currentIndex) return;

    // Get new quote height BEFORE hiding current one
    const newQuote = this.quotes[index];
    if (newQuote && this.quoteWrapper) {
      // Temporarily show new quote to measure it
      newQuote.style.visibility = "hidden";
      newQuote.style.opacity = "0";
      newQuote.classList.add("presse-slider-v2__quote--active");

      const newHeight = newQuote.offsetHeight;

      // Hide it again
      newQuote.classList.remove("presse-slider-v2__quote--active");
      newQuote.style.visibility = "";
      newQuote.style.opacity = "";

      // Set wrapper height to new height
      this.quoteWrapper.style.minHeight = `${newHeight}px`;
    }

    // Hide ALL quotes first (transition period)
    this.quotes.forEach((quote) => {
      quote.classList.remove("presse-slider-v2__quote--active");
    });

    // Update active logo
    this.logos.forEach((logo, i) => {
      if (i === index) {
        logo.classList.add("presse-slider-v2__logo-container--active");
      } else {
        logo.classList.remove("presse-slider-v2__logo-container--active");
      }
    });

    // Update pagination bullets
    const bullets = this.container.querySelectorAll(
      ".swiper-pagination-bullet"
    );
    bullets.forEach((bullet, i) => {
      if (i === index) {
        bullet.classList.add("swiper-pagination-bullet-active");
      } else {
        bullet.classList.remove("swiper-pagination-bullet-active");
      }
    });

    // Show new quote after transition period (all hidden during this time)
    setTimeout(() => {
      this.quotes.forEach((quote, i) => {
        if (i === index) {
          quote.classList.add("presse-slider-v2__quote--active");
        }
      });
    }, 150);

    this.currentIndex = index;
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(
    '[data-section-type="presse-slider-v2"]'
  );
  sections.forEach((section) => {
    new PresseSliderV2(section);
  });
});

document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector('[data-section-type="presse-slider-v2"]')) {
    new PresseSliderV2(event.target);
  }
});

document.addEventListener("shopify:section:unload", (event) => {
  const section = event.target.querySelector(
    '[data-section-type="presse-slider-v2"]'
  );
  if (section && section.presseSliderInstance) {
    section.presseSliderInstance.destroy();
  }
});
